import React from 'react';
import clazz from 'classnames';
import styles from './index.module.less';
export default function InterfaceExperience(props) {
    const { title, className, style = {}, url } = props;
    return (<div id="interface-experience" className={clazz(styles['interface-experience'], className)} style={style}>
      <header>{title}</header>

      <div className={styles['interface-experience-wrapper']}>
        <iframe src={url}/>
      </div>
    </div>);
}
